// extracted by mini-css-extract-plugin
export default {"cardLogosWrapper":"styles_cardLogosWrapper__reJGm"};